import React from 'react';
import styled from '@emotion/styled';

/**
 * PublicFooter Component
 *
 * Sprint 041 Session 1: Footer for public/marketing pages.
 * Adapted from Marketing site's Footer.tsx (pure Emotion, no Mantine deps).
 * Sprint 041 Session 7: Added reCAPTCHA attribution (required per Google ToS when hiding badge).
 */
export const PublicFooter: React.FC = (): React.ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterContent>
        <BrandName>MentionedMe</BrandName>
        <RecaptchaAttribution>
          This site is protected by reCAPTCHA and the Google{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          apply.
        </RecaptchaAttribution>
        <Copyright>&copy; {currentYear} MentionedMe. All rights reserved.</Copyright>
      </FooterContent>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer`
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 32px 24px;
  margin-top: 64px;
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 0 48px;
  }

  @media (min-width: 1200px) {
    padding: 0 64px;
  }
`;

const BrandName = styled.div`
  font-family: 'Comfortaa', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #4d18c4;
  margin-bottom: 4px;
`;

const RecaptchaAttribution = styled.p`
  color: #868e96;
  font-size: 12px;
  margin: 0;
  text-align: center;
  max-width: 480px;

  a {
    color: #868e96;
    text-decoration: underline;

    &:hover {
      color: #495057;
    }
  }
`;

const Copyright = styled.p`
  color: #6c757d;
  font-size: 14px;
  margin: 0;
`;
